<script>
  import LinksToSongs from "./LinksToSongs.svelte";
  export let data = {};
</script>

<section class="loveChart">
  <div class="chart">
    <LinksToSongs data={data?.chapter2?.loveToSongs ?? {}} show="both" />
  </div>
</section>

<style></style>
